<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商城管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name : 'serviceList' }">申请售后</el-breadcrumb-item>
        <el-breadcrumb-item>申请售后详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <h1 class="service-status alert-text">{{ listParams.serviceStatusDisplay }}</h1>

    <div class="hx-form-container box-shadow">
      <el-form
        ref="queryForm"
        :model="listParams"
        label-width="140px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="用户账号：">
              <span class="alert-text">{{ listParams.userAccount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请售后商品：">
              <span class="alert-text">{{ listParams.goodsName}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="下单日期：">
              <span class="alert-text">{{ listParams.orderDate | formatDate }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请日期：">
              <span class="alert-text">{{ listParams.serviceDate | formatDate}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="申请原因：">
              <span class="alert-text">{{ listParams.serviceReason }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="hx-form-container box-shadow">
      <div class="pictures-display">
        <img
          :src="item"
          alt=""
          v-for="(item, index) in listParams.goodsPictures"
          :key="index">
      </div>
    </div>

    <div style="width: 100%;text-align: center;">
      <el-button
        style="width: 120px;"
        v-if="listParams.serviceStatusValue === 1"
        size="small"
        type="primary"
        @click="applyService(serviceId)">
        同意申请
      </el-button>

      <el-button
        style="width: 120px;"
        v-if="listParams.serviceStatusValue === 1"
        size="small"
        type="danger"
        @click="openDialog(serviceId)">
        拒绝申请
      </el-button>

      <el-button
        style="width: 120px;"
        size="small"
        v-if="listParams.serviceStatusValue === 2"
        @click="refundItem(serviceId)">
        退款
      </el-button>
    </div>

    <el-dialog
      class="hx-to-create-template"
      title="拒绝申请"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false">
      <el-form
        ref="dialogForm"
        :rules="checkItemParams"
        :model="itemParams"
        label-width="120px">
        <el-form-item label="拒绝理由 ：" prop="rejectReason">
          <el-input
            type="textarea"
            :rows="4"
            :maxlength="200"
            v-model="itemParams.rejectReason"
            size="small"
            placeholder="请输入拒绝理由(限200字)">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            :disabled="isDisabled"
            size="small"
            type="primary"
            @click="rejectService('dialogForm')">
            确 定
          </el-button>

          <el-button
            size="small"
            @click="cancelReject">
            取 消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  data () {
    return {
      serviceId: '',
      listParams: {
        userAccount: '',
        goodsName: '',
        orderDate: '',
        serviceDate: '',
        serviceReason: '',
        serviceStatusDisplay: '',
        serviceStatusValue: '',
        goodsPictures: []
      },
      itemParams: {
        rejectReason: ''
      },
      checkItemParams: {
        rejectReason: [
          { required: true, message: '请输入拒绝理由(限200字)', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      isDisabled: false
    };
  },
  mounted () {
    const hash = window.location.hash;
    if (hash.indexOf('=') > -1) {
      this.serviceId = hash.substring(hash.indexOf('=') + 1, hash.length);
      this.loadDetailData(this.serviceId);
    }
  },
  methods: {
    /**
       * 加载详情数据
       * @param serviceId
       */
    loadDetailData (serviceId) {
      Vue.ajaxGet(this, global.apiUrl + '/mall/detail', { serviceId: serviceId }).then((res) => {
        Object.assign(this.listParams, res);
      });
    },
    /**
       * 同意申请
       * @param serviceId
       */
    applyService (serviceId) {
      Vue.ajaxPost(this, global.apiUrl + '/mall/passApply', { serviceId: serviceId }).then((res) => {
        this.$message.success(res.info);
        this.loadDetailData(this.serviceId);
      });
    },
    /**
       * 打开对话框
       * @param serviceId
       */
    openDialog (serviceId) {
      this.serviceId = serviceId;
      this.dialogVisible = true;
    },
    /**
       * 拒绝申请
       * @param name
       */
    rejectService (name) {
      this.isDisabled = true;
      this.$refs[name].validate((valid) => {
        if (valid) {
          const bodyParams = Object.assign({}, {
            serviceId: this.serviceId,
            rejectReason: this.itemParams.rejectReason
          });
          this.isDisabled = false;
          Vue.ajaxPost(this, global.apiUrl + '/mall/refuseApply', bodyParams).then((res) => {
            this.$message.success(res.info);
            this.dialogVisible = false;
            this.loadDetailData(this.serviceId);
          });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
       * 关闭对话框
       */
    cancelReject () {
      this.dialogVisible = false;
      this.itemParams.rejectReason = '';
    },
    /**
       * 退款
       * @param serviceId
       */
    refundItem (serviceId) {
      Vue.ajaxPost(this, global.apiUrl + '/mall/refund', { serviceId: serviceId }).then((res) => {
        this.$message.success(res.info);
        this.loadDetailData(this.serviceId);
      });
    }
  }
};
</script>

<style lang="less" scoped>
  .home-container{
    .service-status{
      font-size: 30px;
      margin-bottom: 10px;
    }
    .alert-text{
      color: #E9A021;
      cursor: default;
    }
    .pictures-display{
      width: 100%;
      height: 220px;
      overflow: hidden;
      img{
        width: 200px;
        height: 200px;
        margin-top: 10px;
        margin-left: 10px;
      }
    }
  }
</style>
